/* Mushy · Sale-Bar Countdown
   Zwei Modi:
   - "deadline": zaehlt auf ein festes Datum, danach verschwindet der Timer.
   - "repeat":   zaehlt eine feste Dauer herunter und faengt von vorn an. */

if (!customElements.get('mu-countdown')) {
  customElements.define(
    'mu-countdown',
    class MuCountdown extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode === 'repeat' ? 'repeat' : 'deadline';
        // Schluessel statt Index: so kann dasselbe Element vier Einheiten
        // (Tag/Std/Min/Sek) oder nur drei (Std/Min/Sek) anzeigen.
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.values[el.dataset.unit] = el;
        });

        if (this.mode === 'repeat') {
          this.cycleMs = Math.max(1, parseInt(this.dataset.minutes, 10) || 9) * 60000;
          this.cycleStart = this.readStart();
        } else {
          this.deadline = this.parseDeadline(this.dataset.deadline);
          if (!this.deadline) {
            this.hidden = true;
            return;
          }
        }

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      // Startzeitpunkt pro Besucher merken, damit der Timer beim Seitenwechsel
      // weiterlaeuft statt bei jedem Aufruf neu zu beginnen.
      readStart() {
        const key = 'mu-countdown-' + (this.dataset.key || 'default');
        let start = null;

        try {
          start = parseInt(localStorage.getItem(key), 10);
        } catch (e) {
          // Private Fenster oder blockierter Speicher: dann eben ab jetzt.
        }

        if (!start || isNaN(start) || start > Date.now()) {
          start = Date.now();
          try {
            localStorage.setItem(key, String(start));
          } catch (e) {
            /* nicht schlimm, der Timer laeuft trotzdem */
          }
        }

        return start;
      }

      // "2026-09-30 23:59" -> Date. Ohne Zeitzonen-Suffix liest der Browser das
      // als lokale Zeit des Besuchers, nicht als Shop-Zeitzone.
      parseDeadline(raw) {
        if (!raw) return null;
        const d = new Date(raw.trim().replace(' ', 'T'));
        return isNaN(d.getTime()) ? null : d;
      }

      remaining() {
        if (this.mode === 'repeat') {
          // Modulo statt Neusetzen: der Zyklus startet von selbst wieder,
          // ohne dass bei jedem Durchlauf geschrieben werden muss.
          const elapsed = (Date.now() - this.cycleStart) % this.cycleMs;
          return this.cycleMs - elapsed;
        }
        return this.deadline - Date.now();
      }

      tick() {
        const left = this.remaining();

        if (left <= 0) {
          clearInterval(this.timer);
          this.hidden = true;
          return;
        }

        const s = Math.floor(left / 1000);

        // Ohne Tagesfeld wandern die Tage in die Stunden, sonst faellt die
        // Zeit beim Ueberschreiten von 24 Stunden unter den Tisch.
        const days = Math.floor(s / 86400);
        const parts = {
          d: days,
          h: this.values.d ? Math.floor((s % 86400) / 3600) : Math.floor(s / 3600),
          m: Math.floor((s % 3600) / 60),
          s: s % 60,
        };

        Object.keys(parts).forEach((k) => {
          if (this.values[k]) {
            this.values[k].textContent = String(parts[k]).padStart(2, '0');
          }
        });

        this.setAttribute(
          'aria-label',
          `Noch ${parts.h} Stunden, ${parts.m} Minuten, ${parts.s} Sekunden`
        );
      }
    }
  );
}
